"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissError = exports.receivedGlobalError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var receivedGlobalError = function receivedGlobalError(error) {
  return {
    type: "ERRORS/GLOBAL_ERROR_RECEIVED",
    payload: {
      error: {
        displayMessage: error.displayMessage
      }
    }
  };
};

exports.receivedGlobalError = receivedGlobalError;

var dismissError = function dismissError() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState, context) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: "ERRORS/ERROR_DISMISSED"
              });
              return _context.abrupt("return", new Promise(function (resolve) {
                context.window.setTimeout(function () {
                  dispatch({
                    type: "ERRORS/WAIT_TIME_ELAPSED"
                  });
                  resolve();
                }, 1000);
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.dismissError = dismissError;